<template>
  <CelusButton v-bind="$attrs" color="secondary-container" variant="flat">
    <slot />
  </CelusButton>
</template>

<script setup lang="ts">
import CelusButton from "@/components/util/CelusButton.vue";

defineOptions({
  name: "CelusSecondaryButton",
  inheritAttrs: false,
});
</script>
